"use client";

import React from "react";
import { Twitter, Linkedin, Instagram, Github } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const contactInfo = [{
  label: "(888) 123-4567",
  href: "tel:8881234567"
}, {
  label: "team@quitmytimeshare.com",
  href: "mailto:team@quitmytimeshare.com"
}, {
  label: "1441 Woodmont Ln. NW Suite 488",
  href: "#"
}, {
  label: "Atlanta, GA 30318",
  href: "#"
}];
const socials = [{
  name: "Twitter",
  url: "https://twitter.com",
  icon: Twitter
}, {
  name: "LinkedIn",
  url: "https://linkedin.com",
  icon: Linkedin
}, {
  name: "Instagram",
  url: "https://instagram.com",
  icon: Instagram
}, {
  name: "GitHub",
  url: "https://github.com",
  icon: Github
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="207384" className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-white/5 animate-pulse rounded-md" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-secondary transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="nexus-connect" className="dark bg-background text-foreground border-t border-white/5 pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-20">
          {}
          <div className="flex flex-col gap-6 lg:pr-8">
            <Link to="/" className="inline-block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1627436/img/nexus_group_footer_logo_premium.png" alt="Nexus Group" className="h-9 w-auto object-contain brightness-0 invert opacity-90" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed font-sans">
              At Nexus Group, we empower timeshare owners to break free from unfair contracts through professional and ethical guidance. Our trusted experts provide the clarity you need to regain your financial freedom.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 tracking-tight text-primary">
              Contact Us
            </h3>
            <ul className="flex flex-col gap-3">
              {contactInfo.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-muted-foreground hover:text-secondary transition-colors duration-300 font-sans">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 tracking-tight text-primary">
              Quick Links
            </h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 tracking-tight text-primary">
              Follow Us
            </h3>
            <div className="flex gap-4 mb-8">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.url} newTab className="flex items-center justify-center w-10 h-10 rounded-full bg-white/5 text-muted-foreground hover:bg-secondary hover:text-secondary-foreground transition-all duration-300" aria-label={social.name}>
                    <Icon className="w-4 h-4" />
                  </Link>;
            })}
            </div>
            <div className="bg-secondary/10 border border-secondary/20 p-4 rounded-lg">
              <p className="text-[11px] font-semibold text-secondary uppercase tracking-widest mb-1">
                Mail Documents
              </p>
              <p className="text-xs text-muted-foreground leading-relaxed font-sans">
                1441 Woodmont Ln. NW Suite 488<br />
                Atlanta, GA 30318
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="border-t border-white/5 pt-8">
          <div className="flex flex-col gap-4 text-center">
            <p className="text-[10px] font-mono text-muted-foreground/40 tracking-widest uppercase">
              &copy; {new Date().getFullYear()} NEXUS GROUP. ALL RIGHTS RESERVED.
            </p>
            <p className="text-[9px] font-sans text-muted-foreground/30 max-w-4xl mx-auto leading-relaxed">
              DISCLAIMER: Nexus Group is a professional consulting firm. We provide guidance on timeshare exit strategies based on individual circumstances. No guaranteed results. Every case is unique, and outcomes vary. All client information is strictly confidential.
            </p>
          </div>
        </div>
      </div>
    </section>;
}